module.exports = __webpack_public_path__ + "img/twoBlue.88787ddb.jpg";